import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, StepCard, Reveal } from "../components/ui.js";
import { MascotBot } from "../components/illustrations.js";

/* ============================================================
   LEVELUP ONE — Booking (free consultation form)
   ============================================================ */

export default class Booking extends Component {
  state = {
    form: { name: "", company: "", phone: "", email: "", topic: "AI Solutions", message: "" },
    submitted: false,
    errors: {},
  };
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }

  setField = (k, v) => this.setState((s) => ({ form: { ...s.form, [k]: v }, errors: { ...s.errors, [k]: "" } }));

  validate = () => {
    const { name, phone, email } = this.state.form;
    const errors = {};
    if (!name.trim()) errors.name = "กรุณากรอกชื่อ";
    if (!phone.trim()) errors.phone = "กรุณากรอกเบอร์โทร";
    else if (!/^[0-9+\-\s]{8,15}$/.test(phone.trim())) errors.phone = "เบอร์โทรไม่ถูกต้อง";
    if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) errors.email = "อีเมลไม่ถูกต้อง";
    return errors;
  };

  submit = (e) => {
    e.preventDefault();
    const errors = this.validate();
    if (Object.keys(errors).length) { this.setState({ errors }); return; }
    // เดโม: ไม่มี backend จริง — แสดงสถานะส่งสำเร็จ
    this.setState({ submitted: true });
    window.scrollTo(0, 0);
  };

  render() {
    const { form, errors, submitted } = this.state;
    const steps = [
      { num: "1", time: "วันนี้", title: "กรอกแบบฟอร์ม", desc: "บอกข้อมูลธุรกิจและสิ่งที่อยากแก้" },
      { num: "2", time: "ภายใน 24 ชม.", title: "เรานัดเวลา", desc: "ทีมงานติดต่อกลับเพื่อนัดคุย" },
      { num: "3", time: "30 นาที", title: "ปรึกษาฟรี", desc: "คุยแนวทางและประเมินความเป็นไปได้" },
    ];

    return (
      <div className="nx">
        <Navbar />
        <PageHero
          crumb="พูดคุยกับเรา"
          eyebrow="จองคำปรึกษาฟรี"
          title="คุยกับเรา 30 นาที ไม่มีข้อผูกมัด"
          subtitle="เล่าปัญหาธุรกิจให้เราฟัง แล้วเราจะช่วยประเมินว่าควรเริ่มจากตรงไหน"
        />

        <section className="nx-section">
          <div className="container">
            <div className="row g-5">
              {/* steps */}
              <div className="col-12 col-lg-4">
                <Reveal>
                  <div className="text-center mb-3 d-none d-lg-block">
                    <MascotBot className="" style={{ width: 150, height: "auto" }} />
                  </div>
                  <h3 className="nx-ink mb-4" style={{ fontSize: "1.4rem" }}>ขั้นตอนง่าย ๆ 3 ขั้น</h3>
                  <div className="d-flex flex-column gap-3">
                    {steps.map((s) => <StepCard key={s.num} {...s} />)}
                  </div>
                </Reveal>
              </div>

              {/* form */}
              <div className="col-12 col-lg-8">
                <Reveal delay={120}>
                  <div className="nx-card" style={{ padding: 32 }}>
                    {submitted ? (
                      <div className="text-center py-5">
                        <div style={{ fontSize: "3.4rem" }}>✅</div>
                        <h3 className="nx-ink mt-3">ส่งคำขอเรียบร้อยแล้ว!</h3>
                        <p className="nx-muted">ขอบคุณคุณ {form.name} ทีมงานจะติดต่อกลับภายใน 24 ชั่วโมง</p>
                        <button
                          className="nx-btn nx-btn--ghost mt-3"
                          onClick={() => this.setState({ submitted: false, form: { name: "", company: "", phone: "", email: "", topic: "AI Solutions", message: "" } })}
                        >
                          ส่งคำขอใหม่
                        </button>
                      </div>
                    ) : (
                      <form onSubmit={this.submit} noValidate>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="nx-field">
                              <label className="nx-label">ชื่อ-นามสกุล *</label>
                              <input className="nx-input" value={form.name} onChange={(e) => this.setField("name", e.target.value)} placeholder="ชื่อของคุณ" />
                              {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="nx-field">
                              <label className="nx-label">บริษัท / ร้าน</label>
                              <input className="nx-input" value={form.company} onChange={(e) => this.setField("company", e.target.value)} placeholder="ชื่อกิจการ (ถ้ามี)" />
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="nx-field">
                              <label className="nx-label">เบอร์โทร *</label>
                              <input className="nx-input" value={form.phone} onChange={(e) => this.setField("phone", e.target.value)} placeholder="08x-xxx-xxxx" />
                              {errors.phone && <small className="text-danger">{errors.phone}</small>}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="nx-field">
                              <label className="nx-label">อีเมล</label>
                              <input className="nx-input" value={form.email} onChange={(e) => this.setField("email", e.target.value)} placeholder="you@email.com" />
                              {errors.email && <small className="text-danger">{errors.email}</small>}
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="nx-field">
                              <label className="nx-label">สนใจเรื่อง</label>
                              <select className="nx-select" value={form.topic} onChange={(e) => this.setField("topic", e.target.value)}>
                                <option>AI Solutions</option>
                                <option>เว็บไซต์ / Landing Page</option>
                                <option>Mobile Application</option>
                                <option>ระบบ POS / ERP</option>
                                <option>SaaS Product</option>
                                <option>อื่น ๆ</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="nx-field">
                              <label className="nx-label">รายละเอียดเพิ่มเติม</label>
                              <textarea className="nx-textarea" value={form.message} onChange={(e) => this.setField("message", e.target.value)} placeholder="เล่าปัญหาหรือสิ่งที่อยากทำ..." />
                            </div>
                          </div>
                        </div>
                        <button type="submit" className="nx-btn nx-btn--primary nx-btn--block mt-2">ส่งคำขอปรึกษาฟรี</button>
                        <p className="nx-muted text-center mt-3" style={{ fontSize: "0.84rem" }}>
                          เราจะไม่เปิดเผยข้อมูลของคุณกับบุคคลที่สาม
                        </p>
                      </form>
                    )}
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}
